import { render } from "./Ewaste.vue?vue&type=template&id=72d43b00"
import script from "./Ewaste.vue?vue&type=script&lang=js"
export * from "./Ewaste.vue?vue&type=script&lang=js"

import "./Ewaste.vue?vue&type=style&index=0&id=72d43b00&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__